// extracted by mini-css-extract-plugin
module.exports = {"base":"TableFilterSearch_base__tFjz4","search":"TableFilterSearch_search__1mU1P","footer":"TableFilterSearch_footer__3axuj"};